export default __webpack_public_path__ + "static/media/ic_copy.22ebf1a2.svg";